import {
  Button,
  DatePicker,
  Form,
  SelectMulti,
} from "@telluscompany/design-system";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Download } from "lucide-react";
import { useLocalization } from "@i18n";
import { createLogsExportSchema } from "../../schemas";
import { LogsExportFormData } from "../../types";

export const LogsExportForm = () => {
  const { translate } = useLocalization();

  const form = useForm<LogsExportFormData>({
    resolver: zodResolver(createLogsExportSchema(translate)),
    defaultValues: {
      columns: [],
      startDate: "",
      endDate: "",
    },
  });

  const handleSubmit = (data: LogsExportFormData) => {
    console.log(data);
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)}>
        <div className="mt-6 p-5 rounded-[16px] border">
          <div className="flex items-center gap-4">
            <div className="basis-[900px] min-w-0">
              <SelectMulti
                clearable
                className="w-full"
                control={form.control}
                label={translate("management.log.form.label.columns")}
                name="columns"
                notFoundText={translate(
                  "management.log.form.placeholder.notFound",
                )}
                notMoreOptionsText={translate(
                  "management.log.form.placeholder.notMoreOptions",
                )}
                placeholder={translate(
                  "management.log.form.placeholder.columns",
                )}
                searchPlaceholder={translate(
                  "management.log.form.placeholder.searchColumns",
                )}
                options={[
                  {
                    label: translate("management.log.columns.user"),
                    value: "user",
                  },
                  {
                    label: translate("management.log.columns.action"),
                    value: "action",
                  },
                  {
                    label: translate("management.log.columns.date"),
                    value: "date",
                  },
                  {
                    label: translate("management.log.columns.ip"),
                    value: "ip",
                  },
                  {
                    label: translate("management.log.columns.module"),
                    value: "module",
                  },
                ]}
              />
            </div>
            <DatePicker
              control={form.control}
              dateFormat="shortDateNumeric"
              label={translate("management.log.form.label.startDate")}
              placeholderText={translate("management.log.form.label.startDate")}
              name="startDate"
            />
            <DatePicker
              control={form.control}
              dateFormat="shortDateNumeric"
              label={translate("management.log.form.label.endDate")}
              placeholderText={translate("management.log.form.label.endDate")}
              name="endDate"
            />
            <div className="flex items-end">
              <Button
                type="submit"
                variant="primary"
                size={"small"}
                iconLeft={<Download />}
              >
                {translate("management.log.button.export")}
              </Button>
            </div>
          </div>
        </div>
      </form>
    </Form>
  );
};
